export default __webpack_public_path__ + "static/media/balance-sheet-w.91f67859.png";